import PropTypes from 'prop-types';
import React from 'react';
import Tippy from '~components/tippy';
import { TickSmallWhy } from '~svg-components';

const InputLabelTooltip = React.forwardRef((props, ref) => {
  const { title, children = <TickSmallWhy />, ...otherProps } = props;

  return (
    <Tippy theme="tooltip" {...otherProps} content={title} ref={ref}>
      {children}
    </Tippy>
  );
});

InputLabelTooltip.propTypes = {
  title: PropTypes.node.isRequired,
  children: PropTypes.node,
};

InputLabelTooltip.defaultProps = {
  children: undefined,
};

export default InputLabelTooltip;
